export default __webpack_public_path__ + "static/media/114.e5c5ff39.jpeg";